/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountDTO
 */
export interface UpdateAccountDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateAccountDTO
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAccountDTO
     */
    accountType: UpdateAccountDTOAccountTypeEnum;
}


/**
 * @export
 */
export const UpdateAccountDTOAccountTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type UpdateAccountDTOAccountTypeEnum = typeof UpdateAccountDTOAccountTypeEnum[keyof typeof UpdateAccountDTOAccountTypeEnum];


/**
 * Check if a given object implements the UpdateAccountDTO interface.
 */
export function instanceOfUpdateAccountDTO(value: object): value is UpdateAccountDTO {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('accountType' in value) || value['accountType'] === undefined) return false;
    return true;
}

export function UpdateAccountDTOFromJSON(json: any): UpdateAccountDTO {
    return UpdateAccountDTOFromJSONTyped(json, false);
}

export function UpdateAccountDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'accountType': json['accountType'],
    };
}

export function UpdateAccountDTOToJSON(json: any): UpdateAccountDTO {
    return UpdateAccountDTOToJSONTyped(json, false);
}

export function UpdateAccountDTOToJSONTyped(value?: UpdateAccountDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'accountType': value['accountType'],
    };
}

